export default __webpack_public_path__ + "static/media/icon-ic-chevron-left-gradient.9fa83491.svg";